/* src/app/admin/popi/mappings/popi-list/popi-list.component.scss */
.data-preview-container {
  margin-top: 20px;
  margin-bottom: 30px;
  max-width: 100%;
  overflow-x: auto;
}
.data-preview-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;
  border-radius: 10px;
  overflow: hidden;
}
.data-preview-table th,
.data-preview-table td {
  padding: 8px;
  border: 1px solid #ccc;
  text-align: center;
}
.data-preview-table thead tr {
  background-color: #006f8a;
  color: white;
  font-weight: bold;
}
.data-preview-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.data-preview-table tbody tr:nth-child(odd) {
  background-color: #fff;
}
.data-preview-table tr:hover {
  background-color: #e6f7ff;
}
.loader-wrapper {
  position: relative;
  width: 100px;
  height: 20px;
}
.bar-loader {
  width: 100%;
  height: 4px;
  background:
    linear-gradient(
      to right,
      #3498db 30%,
      #f3f3f3 30%);
  background-size: 200% 100%;
  animation: bar-slide 1.5s linear infinite;
  margin-top: 16px;
}
.loading-text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  font-size: 12px;
  color: #555;
}
@keyframes bar-slide {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}
/*# sourceMappingURL=popi-list.component-MDVFA6AS.css.map */
